import React from 'react'

const SettingsIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.25 9C11.25 7.755 10.245 6.75 9 6.75C7.755 6.75 6.75 7.755 6.75 9C6.75 10.245 7.755 11.25 9 11.25C9.3075 11.25 9.6075 11.19 9.8775 11.07" stroke="#1E293B" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.15991 15.4372L5.97741 15.9097C6.56991 16.2622 7.33491 16.0522 7.68741 15.4597L7.76991 15.3172C8.44491 14.1397 9.55491 14.1397 10.2374 15.3172L10.3199 15.4597C10.6724 16.0522 11.4374 16.2622 12.0299 15.9097L13.3274 15.1672C14.0099 14.7772 14.2424 13.8997 13.8524 13.2247C13.1699 12.0472 13.7249 11.0872 15.0824 11.0872C15.8624 11.0872 16.5074 10.4497 16.5074 9.66219V8.34219C16.5074 7.56219 15.8699 6.91719 15.0824 6.91719C14.3249 6.91719 13.8149 6.61719 13.6349 6.14469C13.4924 5.77719 13.5524 5.29719 13.8524 4.77969C14.2424 4.09719 14.0099 3.22719 13.3274 2.83719L12.7199 2.49219" stroke="#1E293B" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.23 2.68605C9.555 3.86355 8.445 3.86355 7.7625 2.68605L7.68 2.54355C7.335 1.95105 6.57 1.74105 5.9775 2.09355L4.68 2.83605C3.9975 3.22605 3.765 4.10355 4.155 4.78605C4.8375 5.95605 4.2825 6.91605 2.925 6.91605C2.145 6.91605 1.5 7.55355 1.5 8.34105V9.66105C1.5 10.4411 2.1375 11.0861 2.925 11.0861C4.2825 11.0861 4.8375 12.0461 4.155 13.2236" stroke="#1E293B" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        
    )
}

export default SettingsIcon






